import { ClaimRequestRepository } from '../../domain/repositories/ClaimRequestRepository';

export class DeleteClaimRequest {
    constructor(private repository: ClaimRequestRepository) {}

    async execute(claimRequestKey: string) {
        await this.repository.delete(claimRequestKey);
    }
}
